import React, { useEffect, useRef } from "react";

export const ResultPageInfoBox = ({ onClose, infoText, titleText }) => {
  const infoBoxRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (infoBoxRef.current && !infoBoxRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  const titleTextCap = titleText.charAt(0).toUpperCase() + titleText.slice(1);

  return (
    <div className="popup">
      <div className="popup-content" ref={infoBoxRef}>
        <span className="close" onClick={onClose}>
          &times;
        </span>
        <h3>{titleTextCap}</h3>
        <span className="info-text">{infoText}</span>
      </div>
    </div>
  );
};
